export function isProduction(): boolean {
  return process.env.NEXT_JS_ENV === "prod"
}
